(function () {
  'use strict';
  var FSB_ID = 'CartFreeShipping';
  var MOUNT_ID = 'CartCrossSellMount';
  var SECTION = 'cart-cross-sell';
  var fetchCtrl, syncTimer;

  function money(cents) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) {}
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function updateBar(totalCents) {
    var el = document.getElementById(FSB_ID);
    if (!el) return;
    var threshold = parseInt(el.dataset.threshold, 10) || 0;
    if (threshold <= 0) { el.classList.add('hide'); return; }
    var fill = el.querySelector('[data-fsb-fill]');
    var msg = el.querySelector('[data-fsb-msg]');
    var bar = el.querySelector('[role="progressbar"]');
    var remaining = threshold - totalCents;
    var pct = Math.min(100, Math.max(0, (totalCents / threshold) * 100));
    if (fill) fill.style.width = pct + '%';
    if (bar) bar.setAttribute('aria-valuenow', totalCents);
    if (remaining > 0) {
      el.classList.remove('is-complete');
      if (msg) msg.textContent = (el.dataset.msgShort || 'Nog [amount]').replace('[amount]', money(remaining));
    } else {
      el.classList.add('is-complete');
      if (msg) msg.textContent = el.dataset.msgSuccess || 'Gratis verzending!';
    }
  }

  function updateTotals(totalCents) {
    var box = document.querySelector('.tp-totals');
    if (!box) return;
    var threshold = parseInt(box.dataset.threshold, 10) || 0;
    var shipCost = parseInt(box.dataset.shipCost, 10) || 0;
    var freeLabel = box.dataset.freeLabel || 'Gratis';
    var ship = (threshold > 0 && totalCents >= threshold) ? 0 : shipCost;
    var shipEl = box.querySelector('[data-tp-shipping]');
    var totalEl = box.querySelector('[data-tp-total]');
    if (shipEl) shipEl.textContent = ship === 0 ? freeLabel : money(ship);
    if (totalEl) totalEl.textContent = money(totalCents + ship);
  }

  function refreshCrossSell() {
    var mount = document.getElementById(MOUNT_ID);
    if (!mount) return;
    if (fetchCtrl) fetchCtrl.abort();
    fetchCtrl = new AbortController();
    fetch('/?sections=' + SECTION, { signal: fetchCtrl.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION] || data[Object.keys(data)[0]] || '';
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('.cart-cross-sell-inner');
        mount.innerHTML = inner ? inner.outerHTML : '';
      })
      .catch(function () {});
  }

  function onCart(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    var fsb = document.getElementById(FSB_ID);
    if (fsb) fsb.classList.toggle('hide', cart.item_count <= 0);
    updateBar(cart.total_price);
    updateTotals(cart.total_price);
    var mount = document.getElementById(MOUNT_ID);
    if (cart.item_count > 0) refreshCrossSell();
    else if (mount) mount.innerHTML = '';
  }

  function sync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(onCart)
        .catch(function () {});
    }, 60);
  }

  function attachObserver() {
    var products = document.querySelector('[data-products]');
    if (!products) return;
    new MutationObserver(sync).observe(products, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ccs-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.dataset.variantId;
    if (!id) return;
    btn.classList.add('is-loading');
    btn.setAttribute('disabled', 'disabled');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        if (window.dataLayer) window.dataLayer.push({ event: 'cart_cross_sell_add', variant_id: id });
      })
      .catch(function () {})
      .finally(function () { btn.classList.remove('is-loading'); btn.removeAttribute('disabled'); });
  });

  document.addEventListener('cart:updated', function () { sync(); });

  document.addEventListener('DOMContentLoaded', function () {
    attachObserver();
    sync();
  });
})();

(function () {
  function mainImg(card) { return card ? card.querySelector('.grid-product__image-mask img') : null; }
  function swap(sw) {
    var card = sw.closest('.grid-product__content'); if (!card) return;
    var img = mainImg(card); if (!img || !sw.dataset.img) return;
    if (img.dataset.tpOrig === undefined) {
      img.dataset.tpOrig = img.getAttribute('src') || '';
      img.dataset.tpOrigSet = img.getAttribute('srcset') || '';
    }
    img.setAttribute('src', sw.dataset.img);
    img.removeAttribute('srcset');
    card.classList.add('tp-color-hover');
  }
  function restore(sw) {
    var card = sw.closest('.grid-product__content'); if (!card) return;
    var img = mainImg(card); if (!img) return;
    if (img.dataset.tpOrig !== undefined) {
      if (img.dataset.tpOrig) img.setAttribute('src', img.dataset.tpOrig);
      if (img.dataset.tpOrigSet) img.setAttribute('srcset', img.dataset.tpOrigSet);
    }
    card.classList.remove('tp-color-hover');
  }
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.tp-card-swatch[data-img]');
    if (sw) swap(sw);
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('.tp-card-swatch[data-img]');
    if (!sw) return;
    var to = e.relatedTarget;
    if (to && to.closest) {
      var to2 = to.closest('.tp-card-swatch[data-img]');
      if (to2 && to2.closest('.grid-product__content') === sw.closest('.grid-product__content')) return;
    }
    restore(sw);
  });
})();